import styled from 'styled-components';
import { tokens, palette } from '../../styles';

const getMargin = arr => {
  const converted = arr.map(item => tokens.spacing[item]);

  return converted.join(' ');
};

export const Tag = styled.p`
  // by default, inherits from parent
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  text-decoration: none;

  &[href],
  &[href]:hover {
    color: ${palette['color-brand-primary']};
  }
  // set the cursor as pointer if it's a link
  ${({ isLink }) => isLink && 'cursor: pointer;'}

  // get the color or inherit from parent
  ${({ color }) => `color: ${palette[`color-${color}`]};`}

  // get the font size or inherit from parent
  ${({ size }) => tokens.font[size]}

  // get the font weight if applies or get the default font weight as provided by browser
  ${({ weight }) => weight && `font-weight: ${tokens.font.weight[weight]}`}

  ${({ margin }) => margin && `margin: ${getMargin(margin)}`}
`;
